import Vue from 'vue'
import Vuex from 'vuex'
import authService from '@/services/auth'
import applyStudentService from '@/services/applyStudent'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //src: 'https://localhost:7020',
    //subDirectory: '',
    src: 'https://nthuoga.thinker.tw',
    subDirectory: '/Core',
    user: null,
    isAuthenticated: false,
    loginJWT: null,
  },
  getters: {
    isLoggedIn: state => state.isAuthenticated,
    currentUser: state => state.user,
    userAccount: state => state.user ? state.user.Account : null,
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      state.isAuthenticated = !!user;
    },
    SET_JWT(state, token) {
      state.loginJWT = token;
    },
    LOGOUT(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.loginJWT = null;
    },
  },
  actions: {
    async initAuth({ commit }) {
      if (authService.isAuthenticated()) {
        const user = authService.getCurrentUser();
        const jwt = localStorage.getItem('loginJWT');
        commit('SET_USER', user);
        commit('SET_JWT', jwt);
      }
    },
    async login({ commit }, credentials) {
      const result = await authService.login(credentials);
      if (result.success) {
        commit('SET_USER', {
          Account: result.data.Account,
          Name: result.data.Name,
          Email: result.data.Email,
        });
        commit('SET_JWT', result.data.LoginJWT);
      }
      return result;
    },
    async register(_, userData) {
      return await authService.register(userData);
    },
    async forgotPassword(_, email) {
      return await authService.forgotPassword(email);
    },
    async resetPassword(_, resetData) {
      return await authService.resetPassword(resetData);
    },
    async activateAccount(_, activationData) {
      return await authService.activateAccount(activationData);
    },
    async checkUserApplication() {
      return await applyStudentService.checkUserApplication();
    },
    async checkActiveApplyPeriod() {
      return await applyStudentService.checkActiveApplyPeriod();
    },
    async getActiveApplyTerms() {
      return await applyStudentService.getActiveApplyTerms();
    },
    logout({ commit }) {
      authService.logout();
      commit('LOGOUT');
    },
  },
  modules: {
  }
})
